export enum TutorBillingPaymentService {
  Gcash = 'GCASH',
  Paypal = 'PAYPAL',
  Payoneer = 'PAYONEER',
  Wire = 'WIRE',
}
